// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1501":"87a8bdc06f131293","2888":"4c611c321061b49a"}[chunkId] + ".css";
};